import React, { useEffect } from 'react';

/* ────────────────────────────────────────────────────────────────
   Diamantregen-Hintergrund (nur Nachtansicht).

   ENTFERNEN/DEAKTIVIEREN: einfach DIAMOND_RAIN_ENABLED auf false
   setzen — mehr ist nicht nötig. (Alternativ die Zeile
   <DiamondRainBackground /> in PresentationPage.jsx löschen.)
   ──────────────────────────────────────────────────────────────── */
export const DIAMOND_RAIN_ENABLED = true;

export default function DiamondRainBackground() {
  useEffect(() => {
    if (!DIAMOND_RAIN_ENABLED) return undefined;
    document.body.classList.add('diamond-rain-on');
    return () => document.body.classList.remove('diamond-rain-on');
  }, []);

  if (!DIAMOND_RAIN_ENABLED) return null;

  return (
    <div className="diamond-rain-bg" aria-hidden data-testid="diamond-rain-bg">
      <video
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        data-slide-persist="true"
        data-testid="diamond-rain-video"
      >
        <source src="/videos/diamond-rain-bg.webm" type="video/webm" />
        <source src="/videos/diamond-rain-bg.mp4" type="video/mp4" />
      </video>
      <div className="diamond-rain-bg__shade" />
    </div>
  );
}
